<div class="cc-embed-toolbar" *ngIf="showToolbarChrome">
  <div class="cc-embed-toolbar__left">
    <i [class]="sectionIconClass + ' cc-embed-toolbar__icon'" aria-hidden="true"></i>
    <span class="cc-embed-toolbar__title">{{ title }}</span>
  </div>

  <div class="cc-embed-toolbar__actions">
    <div class="cc-embed-toolbar__action" *ngIf="nav.headerIsUtilityButtonUsed">
      <span class="cc-embed-utility">
        <ng-template [ngTemplateOutlet]="nav.headerUtilityButtonTemplate"></ng-template>
      </span>
    </div>

    <div class="cc-embed-toolbar__action" *ngIf="headerIsFullscreenAllowedTemp">
      <div ngbDropdown placement="bottom-right">
        <button
          class="btn cc-embed-bar-btn"
          ngbDropdownToggle
          type="button"
          ngx-tooltip
          [tooltipType]="'tooltip'"
          [tooltipTemplate]="fsTip"
        >
          <ng-template #fsTip>
            <span class="tooltip-label"></span>
            <span class="tooltip-value">{{ 'Toggle to Fullscreen View' }}</span>
            <span class="tooltip-label"></span>
          </ng-template>
          <i class="fa fa-fw fa-expand"></i>
        </button>
        <div ngbDropdownMenu>
          <a ngbDropdownItem (click)="screenFullService.turnOn(true)">On Device</a>
          <a ngbDropdownItem (click)="screenFullService.turnOn()">In Browser</a>
        </div>
      </div>
    </div>

    <div class="cc-embed-toolbar__action" *ngIf="sidePanel.isUsed">
      <button
        class="btn cc-embed-bar-btn"
        [ngClass]="sidePanel.isVisible ? 'cc-embed-bar-btn--active' : ''"
        type="button"
        (click)="sidePanel.toggle()"
        ngx-tooltip
        [tooltipType]="'tooltip'"
        [tooltipTemplate]="filterTip"
      >
        <ng-template #filterTip>
          <span class="tooltip-label"></span>
          <span class="tooltip-value">{{ sidePanel.isVisible ? 'Hide Side Panel' : 'Show Side Panel' }}</span>
          <span class="tooltip-label"></span>
        </ng-template>
        <i class="fa fa-fw fa-filter"></i>
      </button>
    </div>
  </div>
</div>

<div
  #subHeader
  *ngIf="showSubHeader && subHeaderTemplate"
  class="cc-embed-subheader"
>
  <ng-template [ngTemplateOutlet]="subHeaderTemplate"></ng-template>
</div>
